import { ICellRendererComp, ICellRendererParams } from '@ag-grid-community/core';
import { MaturityAmountEntry } from './maturity-amount-entry';

export type MaturityAmountRendererParams = ICellRendererParams & {
  maxAmount: string;
  orderAmount: string;
  allActive: boolean;
  disabled?: boolean;
  showSplitButton?: boolean;
  splitActive?: boolean;
  amountReadonly?: boolean;
  changeListener: (any) => void;
  allListener: (any) => void;
  splitListener?: () => void;
};

export class MaturityAmountRenderer implements ICellRendererComp {
  params: MaturityAmountRendererParams;

  eGui: HTMLElement;

  invalid: boolean;

  maturityAmountEntry: MaturityAmountEntry;

  private allEventHandler = (event: CustomEvent) => {
    // Use current params in case they've been updated
    this.params.allListener(event.detail);
  };

  private changeEventHandler = (event: CustomEvent) => {
    // Use current params in case they've been updated
    this.params.changeListener(event.detail);
  };

  private splitEventHandler = () => {
    this.params.splitListener?.();
  };

  init(params: MaturityAmountRendererParams) {
    this.params = params;
    this.maturityAmountEntry = document.createElement(
      'maturity-amount-entry',
    ) as MaturityAmountEntry;
    this.maturityAmountEntry.addEventListener('change', this.changeEventHandler);
    this.maturityAmountEntry.addEventListener('all', this.allEventHandler);
    this.maturityAmountEntry.addEventListener('split', this.splitEventHandler);

    // Pass AG Grid context for cell navigation
    this.maturityAmountEntry.gridApi = params.api;
    this.maturityAmountEntry.node = params.node;
    this.maturityAmountEntry.column = params.column;

    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.height = '100%';
    this.eGui.style.width = '100%';
    this.eGui.append(this.maturityAmountEntry);
    this.render();
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: MaturityAmountRendererParams) {
    this.params = params;
    // Update AG Grid context on refresh
    this.maturityAmountEntry.gridApi = params.api;
    this.maturityAmountEntry.node = params.node;
    this.maturityAmountEntry.column = params.column;
    this.render();
    return true;
  }

  private render(): void {
    this.maturityAmountEntry.setAttribute('max-amount', this.params.maxAmount);

    if (this.params.disabled) {
      this.maturityAmountEntry.setAttribute('disabled', '');
      this.maturityAmountEntry.disabled = true;
    } else {
      this.maturityAmountEntry.removeAttribute('disabled');
      this.maturityAmountEntry.disabled = false;
    }

    if (this.params.amountReadonly) {
      this.maturityAmountEntry.setAttribute('amount-readonly', '');
      this.maturityAmountEntry.amountReadonly = true;
    } else {
      this.maturityAmountEntry.removeAttribute('amount-readonly');
      this.maturityAmountEntry.amountReadonly = false;
    }

    if (this.params.allActive) {
      this.maturityAmountEntry.setAttribute('all-active', '');
    } else {
      this.maturityAmountEntry.removeAttribute('all-active');
    }
    if (this.params.showSplitButton) {
      this.maturityAmountEntry.setAttribute('show-split-button', '');
      this.maturityAmountEntry.showSplitButton = true;
    } else {
      this.maturityAmountEntry.removeAttribute('show-split-button');
      this.maturityAmountEntry.showSplitButton = false;
    }
    if (this.params.splitActive) {
      this.maturityAmountEntry.setAttribute('split-active', '');
      this.maturityAmountEntry.splitActive = true;
    } else {
      this.maturityAmountEntry.removeAttribute('split-active');
      this.maturityAmountEntry.splitActive = false;
    }
    this.maturityAmountEntry.setAttribute('value', this.params.orderAmount ?? '');
  }
}
